import type { Location } from 'react-router';

/**
 * Where someone was going before they were asked to sign in.
 *
 * Carried in the router's location state rather than in a `?next=` query
 * parameter. That keeps the destination out of the address bar, out of browser
 * history and out of the referrer header of anything the login page loads -- and
 * it means nobody can hand someone a login link that sends them somewhere else
 * afterwards, because the value never comes from the URL.
 */
export interface LoginRedirectState {
  readonly from: string;
}

export function loginRedirectState(location: Location): LoginRedirectState {
  return { from: `${location.pathname}${location.search}` };
}

export function intendedDestination(state: unknown): string | null {
  if (typeof state !== 'object' || state === null || !('from' in state)) {
    return null;
  }
  const from: unknown = (state as { from: unknown }).from;
  // Only a path. An absolute URL here would be an open redirect waiting to be
  // pointed at somebody else's host.
  return typeof from === 'string' && from.startsWith('/') && !from.startsWith('//') ? from : null;
}
